// extracted by mini-css-extract-plugin
export default {"container":"Search_container__JDaLY","input":"Search_input__PXR0c","searchIcon":"Search_searchIcon__a+82O","closeButton":"Search_closeButton__QUtPk"};